export default __webpack_public_path__ + "static/media/laptop.9dc96a3e.jpg";